import React from 'react';
import ReactDOM from 'react-dom';
import {
  SageClassnames,
  Modal,
  Frame,
  IconCard,
  Button,
  Icon,
  SageTokens,
} from '@kajabi/sage-react';

type Props = {
  errorMessage: string;
};
const noop = () => {};

const ConversationAssistantFullscreenError = ({ errorMessage }: Props) => {
  const handleRestart = () => {
    window.location.reload();
  };

  return ReactDOM.createPortal(
    <Modal fullScreen active onExit={noop} className="copy-magic-conversation-assistant-fullscreen">
      <Modal.Body>
        <div
          data-testid="copy-magic-error-message-fullscreen"
          className={[SageClassnames.TYPE.BODY_SMALL, 'copy-magic-error-fullscreen'].join(' ')}
        >
          <Frame
            direction={Frame.DIRECTIONS.VERTICAL}
            padding={Frame.PADDINGS.MD}
            align={Frame.ALIGNMENTS.CENTER_CENTER}
            width={Frame.WIDTHS.FLEX}
            className={SageClassnames.TYPE_ALIGN_CENTER}
          >
            <IconCard
              color={IconCard.COLORS.DANGER}
              icon={SageTokens.ICONS.WARNING_FILLED}
              size={Icon.SIZES.XL}
              style={{ maxWidth: 70, marginRight: 'auto', marginLeft: 'auto', padding: 20 }}
            />
            {errorMessage}
            <Button onClick={handleRestart} color={Button.COLORS.PRIMARY} icon={Icon.ICONS.SYNC}>
              Refresh page
            </Button>
          </Frame>
        </div>
      </Modal.Body>
    </Modal>,
    document.body,
  );
};

export default ConversationAssistantFullscreenError;
